import { makeStyles } from '@material-ui/styles';
import {
    white,
    gallery,
    silver,
    silverChalice,
} from '../../../constants/Colors';

export default makeStyles(() => ({
    container: {
        display: 'flex',
        flexFlow: 'row',
        backgroundColor: white,
        padding: '8px 10px',
        borderTop: ({ alignment }) => (alignment === 'bottom' ? `1px solid ${silver}` : 'none'),
        borderBottomLeftRadius: ({ alignment }) => (alignment === 'bottom' ? '3px' : '0'),
        borderBottomRightRadius: ({ alignment }) => (alignment === 'bottom' ? '3px' : '0'),
        borderBottom: ({ alignment }) => (alignment === 'top' ? `1px solid ${silver}` : 'none'),
        borderTopLeftRadius: ({ alignment }) => (alignment === 'top' ? '3px' : '0'),
        borderTopRightRadius: ({ alignment }) => (alignment === 'top' ? '3px' : '0'),
    },
    buttonSet: {
        display: 'flex',
        flexFlow: 'row',
    },
    button: {
        padding: '9px 10px',
        fontSize: '13px',
        lineHeight: '1.5',
        borderRadius: '3px',
        border: `1px solid ${silver}`,
        display: 'inline-block',
        textAlign: 'center',
        verticalAlign: 'middle',
        cursor: 'pointer',
        background: white,
        margin: '3px',
        '&.active': {
            background: gallery,
            borderColor: silverChalice,
        },
    },
}));
